// libraries
import StackIcon from "tech-stack-icons";

const experienceData = [
    { icon: <StackIcon name={"go"} className="w-12" />, years: 2, label: 'Golang'},
    { icon: <StackIcon name={"typescript"} className="w-12" />, years: 4, label: 'Typescript'},
    { icon: <StackIcon name={"python"}  className="w-12" />, years: 3, label: 'Python' },
    { icon: <StackIcon name={"nodejs"}  className="w-12" />, years: 3, label: 'Node.js' },
    { icon: <StackIcon name={"react"}  className="w-12" />, years: 3, label: 'React' },
    { icon: <StackIcon name={"angular"}  className="w-12" />, years: 4, label: 'Angular' },
];

const Languages = () => (
    <div className="flex flex-col items-center mt-8">
        <h2 className="mb-6 text-2xl font-bold flex items-center gap-2">
            <span role="img" aria-label="books">📚</span>
            Languages
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 md:flex flex-1 flex-col md:flex-row gap-2">
            {experienceData.map((exp) => (
                <div
                    key={exp.label}
                    className="flex flex-col items-center p-4 border border-gray-200 rounded-lg min-w-[100px] bg-gray-50"
                >
                    {exp.icon}
                    <span className="font-bold text-2xl my-2">
                        {exp.years}
                    </span>
                    {/* <span className="text-base text-gray-600">{exp.label}</span> */}
                </div>
            ))}
        </div>
    </div>
);

export default Languages;